import { Component, Input } from '@angular/core';

/**
 *
 * @description Component used for adding hidden text to buttons,
 * links and other interactive elements that only contain img / icon or other non-readable content
 *
 * @param id Id to map to aria-laballedby
 */
@Component({
  selector: 'app-sr-text',
  templateUrl: './sr-text.component.html',
  styleUrls: ['./sr-text.component.scss'],
  standalone: false
})
export class SrTextComponent {
  @Input() fieldId = '';
}
